import Common from '../../Common';

const Callers = class extends Common {
	async read(queueId: id) {
		return this.get(`/queue/${queueId}/caller`);
	}

	async pickup(id: id, callerId: id) {
		return this.post(`/queue/${id}/caller/${callerId}/pickup`);
	}
}

export default Callers;
